export const TEXT_ROW = 'TEXT_ROW';
export const ADD_ROW = 'ADD_ROW';
export const GROUP_SUMMARY = 'GROUP_SUMMARY';
export const CREATE_GROUP = 'CREATE_GROUP';
export const EDIT_GROUP_NAME = 'EDIT_GROUP_NAME';
export const COLOR_FILTER = 'COLOR_FILTER';
